<template>
    <div>
        <b-row>
            <b-col cols="1">
                Validée
            </b-col>
            <b-col cols="3">
                <div class="ml-3">Libellé</div>
            </b-col>
            <b-col cols="2">
                <div class="ml-3">
                    <label-custom
                            label="Montant global du marché"
                            tooltip="Montant global du marché"
                            :required="true">
                    </label-custom>
                </div>
            </b-col>
            <b-col cols="2">
                <div class="ml-3">
                    <label-custom
                            label="Objectif PME"
                            tooltip="Indiquer l'objectif contractualisé de la clause d'accès des TPE/PME (figure dans l'AE)"
                            :required="true">
                    </label-custom>
                </div>
            </b-col>
            <b-col cols="2">
                <div class="ml-3">
                    <label-custom
                            label="Objectif insertion"
                            tooltip="Indiquer l'objectif contractualisé pour la clause d'insertion par l'activité économique (figure dans l'AE)"
                            :required="true">
                    </label-custom>
                </div>
            </b-col>
        </b-row>
        <template v-for="(n, i) in tranchesCount">
            <b-row :key="'row_' + i" class="mb-2">
                <b-col cols="1" class="pt-2 pl-4">
                    <b-form-checkbox
                            v-model="tranches[i].validee"
                            :value="true"
                            :unchecked-value="false">
                    </b-form-checkbox>
                </b-col>
                <b-col cols="3">
                    <b-form-input
                            v-model="tranches[i].libelle"
                            type="text"
                            :trim="true"
                            @input="emit"
                            required>
                    </b-form-input>
                </b-col>
                <b-col cols="2">
                    <b-form-input
                            v-model="tranches[i].montantGlobal"
                            type="number"
                            step="any"
                            min="0"
                            :trim="true"
                            @input="emit"
                            class="objectifs"
                            required>
                    </b-form-input>
                </b-col>
                <b-col cols="2">
                    <b-form-input
                            v-model="tranches[i].objectifPme"
                            type="number"
                            step="any"
                            min="0"
                            :trim="true"
                            @input="emit"
                            class="objectifs"
                            required>
                    </b-form-input>
                </b-col>
                <b-col cols="2">
                    <b-form-input
                            v-model="tranches[i].objectifInsertion"
                            type="number"
                            min="0"
                            step="any"
                            :trim="true"
                            @input="emit"
                            class="objectifs"
                            required>
                    </b-form-input>
                </b-col>
                <b-col cols="1" v-if="n === tranchesCount && tranches[i] != null">
                    <Icon icon="plus" size="2x" :key="'add_' + i" @click="addSelect"
                          class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
                <b-col cols="1" v-if="tranchesCount === n && n > 1">
                    <Icon icon="minus" size="2x" :key="'remove_' + i"
                          @click="removeSelect(i)" class="pt-2 typo-grey cursor-pointer"></Icon>
                </b-col>
            </b-row>
        </template>
    </div>

</template>

<script>
  import MarcheTrancheDto from "../../dtos/MarcheTrancheDto";
  import LabelCustom from "../../components/LabelCustom";

  export default {
    name: "TrancheMarche",
    props: ['value'],
    components: {LabelCustom},
    data() {
      return {
        tranchesCount: 1,
        tranches: [new MarcheTrancheDto()],
      }
    },
    watch: {
      value: function (vals) {
        this.initTranches(vals);
      }
    },
    mounted() {
      this.initTranches(this.value);
    },
    methods: {
      initTranches(vals) {
        if (vals && vals.length > 0) {
          this.tranches = vals;
          this.tranchesCount = vals.length;
        } else {
          this.tranches = [new MarcheTrancheDto()];
          this.tranchesCount = 1;
        }
      },
      emit() {
        this.$emit('input', this.tranches);
      },
      addSelect() {
        this.tranches.push(new MarcheTrancheDto());
        this.tranchesCount++;
      },
      removeSelect(index) {
        this.tranchesCount--;
        this.tranches.splice(index, 1);
        this.emit();
      }
    }
  };
</script>

